import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LoginMethod, setUser } from 'store/slices/authSlice';
import toast from 'react-hot-toast';
import { googleOAuthCallback } from 'api/authApi';

const GoogleOAuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const fetchUserInfo = async (code: string) => {
    if (!code) {
      const errorMessage = 'No authentication code found!';
      setError(errorMessage);
      toast.error(errorMessage);
      return;
    }

    try {
      const { success, data } = await googleOAuthCallback(code); // API call

      if (success) {
        const { user_id, username, display_name, img_url, access_token } = data;
        dispatch(
          setUser({
            user: {
              userId: user_id,
              username,
              displayName: display_name,
              imgUrl: img_url,
              loginMethod: LoginMethod.GOOGLE,
            },
            accessToken: access_token,
          })
        );
        toast.success('Successfully logged in with Google');
        navigate(-3);
      }
    } catch (error) {
      const errorMessage = 'Failed to login with Google. Please try again.';
      console.error('Error fetching user info:', error);
      setError(errorMessage);
      toast.error(errorMessage);
      // Optionally navigate to login page after error
      setTimeout(() => navigate('/auth/login'), 2000);
    }
  };

  useEffect(() => {
    const code = searchParams.get('code');
    if (code) {
      toast.loading('Logging in with Google...', {
        duration: 2000, // Toast will dismiss after 2 seconds
      });
      fetchUserInfo(code);
    }
  }, [searchParams]);

  return (
    <div className="flex items-center justify-center h-screen">
      <p>{error || 'Logging you in...'}</p>
    </div>
  );
};

export default GoogleOAuthCallback;
